import api from "./api";

export async function getFiles (q= '', page = 1, param = '', type='indicators') {
    return api.get(`/files?page=${page}&q=${q}&with=${param}&type=${type}&sortDirection=desc&paginate=true`)
}

export async function getDocuments (q= '', page = 1) {
    return api.get(`/documents?page=${page}&q=${q}&sortDirection=desc&paginate=true`)
}

export async function getFile (url) {
    return api.get(url,{responseType: 'blob'})
        .then(response => response)
        .catch(error => console.log(error.response));
}

export function delDocument(id) {
    return api.delete(`documents/${id}`)
        .then(response => response)
        .catch(error => console.log(error.response));
}
